import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';
import { 
  MessageSquare, 
  CheckCircle, 
  AlertCircle, 
  Clock, 
  TrendingUp,
  TrendingDown,
  Users,
  BarChart3
} from 'lucide-react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const CallsPerHour = ({ data }: { data: any }) => {
  const [loading, setLoading] = useState(true);
  
    const [callsTrend, setCallsTrend] = useState<any[]>([]);
  
    useEffect(() => {
      setLoading(true);
      setTimeout(() => {
  
        setCallsTrend(data?.calls_per_hour ?? []);


  
  
        setLoading(false);
      }, 800);
    }, [data]);
return (    
  <>
    <div className="col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <div className="card shadow-sm border-0 h-100">
        <div className="card-header border-0 pt-5">
            <h3 className="card-title align-items-start flex-column">
            <span className="card-label fw-bold text-dark fs-5"><TrendingUp size={18} className="me-2 text-primary"/>Data Calls Per Hour</span>
            </h3>
        </div>
        <div className="card-body">
            <div style={{ width: '90%', height: 200 }}>
            <ResponsiveContainer>
                <LineChart data={callsTrend}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f3f3" />
                <XAxis dataKey="hour" axisLine={false} tickLine={false} />
                <YAxis axisLine={false} tickLine={false} />
                <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 5px 15px rgba(0,0,0,0.1)' }} />
                <Line type="monotone" dataKey="answer" stroke="#22b854ff" strokeWidth={3} dot={{ r: 4 }} activeDot={{ r: 6 }} name="Answer" />
                <Line type="monotone" dataKey="no_answer" stroke="#cd5050ff" strokeWidth={3} dot={{ r: 4 }} name="No Answer" />
                <Line type="monotone" dataKey="abandoned" stroke="#faf60cff" strokeWidth={3} dot={{ r: 4 }} name="Abandoned" />
                </LineChart>
            </ResponsiveContainer>
            </div>
        </div>
        </div>
    </div>

  </>
)
}
export default CallsPerHour;